<div class="invite-collaborator-wrapper col">
  <div class="invite-collaborator col">
    <div class="header row">
      <div class="title bold">
        Invite Collaborators
      </div>
      <div class="close col va-c" (click)="close()">
        <mat-icon>close</mat-icon>
      </div>
    </div>
    <div class="content col">
      <form [formGroup]="collaboratorsForm">
        <div class="internal-collaborators row va-c mt-10">
          <div class="collaborator row va-c" *ngFor="let collaborator of selectedCollaborators; let i = index;">
            <div class="text">{{collaborator?.firstName}} {{collaborator?.lastName}}</div>
            <div class="close row va-c ha-c c-p bold" (click)="removeCollaborator(i)">x</div>
          </div>
          <mat-form-field class="collaborators">
            <input type="text"
                   matInput
                   formControlName="internalCollaborators"
                   [matAutocomplete]="internalCollaboratorsAutoComplete">

            <mat-autocomplete (optionSelected)="onSelectCollaborator($event.option.value)"
                              #internalCollaboratorsAutoComplete="matAutocomplete"
                              [displayWith]="displayWithCollaborator">
              <mat-option class="select-label" *ngFor="let collaborator of data.internalCollaborators | async"
                          [value]="collaborator">
                {{collaborator?.firstName}} {{collaborator?.lastName}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div class="error-message" *ngIf="errorMessage" style="color: #f44336; margin-top: 8px; font-size: 14px;">
          {{ errorMessage }}
        </div>
      </form>
    </div>
    <div class="footer row">
      <button mat-stroked-button color="warn" class="close-btn uppercase" (click)="close()">Close</button>
      <button mat-raised-button color="primary" class="create-btn uppercase" (click)="inviteCollaborators()">Invite
      </button>
    </div>
  </div>
</div>
